import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'




import StyledError from '../../../../components/StyledError'
import Toggle from '../../../../components/Toggle/Toggle'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useMutationProps from '../../../../hooks/useMutationProps'
import SetSlackNotificationMutation from '../../../../mutations/SetSlackNotificationMutation'
import {MeetingLabels} from '../../../../types/constEnums'








const labelLookup = {
  meetingEnd: 'Meeting End',
  meetingStart: 'Meeting Start',
  MEETING_STAGE_TIME_LIMIT_END: `Meeting ${MeetingLabels.TIME_LIMIT} Ended`,
  MEETING_STAGE_TIME_LIMIT_START: `Meeting ${MeetingLabels.TIME_LIMIT} Started`,
  TOPIC_SHARED: `Topic Shared`,
  STANDUP_RESPONSE_SUBMITTED: 'Standup Response Submitted'
} 

const Row = styled('div')({
  alignItems: 'center',
  display: 'flex',
  padding: '8px 0'
})

const Label = styled('span')({
  fontSize: 14,
  marginRight: 16,
  width: '100%'
})

const SlackNotificationRow = (props) => {
  const {event, localChannelId, teamId, viewer: viewerRef} = props
  const viewer = useFragment(
    graphql`
      fragment SlackNotificationRow_viewer on User {
        teamMember(teamId: $teamId) {
          integrations {
            slack {
              notifications {
                channelId
                event
              }
            }
          }
        }
      }
    `,
    viewerRef
  )
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {slack} = integrations
  const notifications = _nullishCoalesce(_optionalChain([slack, 'optionalAccess', _ => _.notifications]), () => ( []))
  const label = labelLookup[event]
  const atmosphere = useAtmosphere()
  const existingNotification = notifications.find((notification) => notification.event === event)
  const active = !!(existingNotification && existingNotification.channelId)
  const {error, submitMutation, onCompleted, onError, submitting} = useMutationProps()
  const onClick = () => {
    if (submitting) return
    submitMutation()
    const slackChannelId = active ? null : localChannelId
    SetSlackNotificationMutation(
      atmosphere,
      {slackChannelId, slackNotificationEvents: [event ], teamId},
      {
        onError,
        onCompleted
      }
    )
  }

  // does not show disabled when submitting because the temporary disabled mouse icon is ugly
  return (
    _jsxs(_Fragment, { children: [
      _jsxs(Row, { children: [
        _jsx(Label, { children: label})
        , _jsx(Toggle, { active: active, disabled: !localChannelId, onClick: onClick,} )
      ]})
      , error && _jsx(StyledError, { children: error.message})
    ]})
  )
}

export default SlackNotificationRow
